import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Relates a `}<a parentName="p" {...{
          "href": "/api/../api/projects/customers#customer"
        }}>{`Customer`}</a>{` to the order. In case the customer belongs to a `}<a parentName="p" {...{
          "href": "/api/../api/projects/customerGroups#customergroup"
        }}>{`CustomerGroup`}</a>{` the order's field `}<inlineCode parentName="p">{`customerGroup`}</inlineCode>{` would be updated automatically. When applied, no prices or discounts will be re-calculated on the order.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setCustomerId"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`customerId`}</inlineCode>{` - String - Optional`}<br parentName="li"></br>
          {`If set, a `}<a parentName="li" {...{
            "href": "/api/../api/projects/customers#customer"
          }}>{`Customer`}</a>{` with the given ID must exist in the project.`}</li>
      </ul>
      <p parentName="section">{`This update action produces an `}<a parentName="p" {...{
          "href": "/api/../api/projects/messages#order-customer-set"
        }}>{`OrderCustomerSet`}</a>{` Message.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      